import { render, staticRenderFns } from "./RealTimeStatus.vue?vue&type=template&id=c1a21f5a&scoped=true"
import script from "./RealTimeStatus.vue?vue&type=script&lang=js"
export * from "./RealTimeStatus.vue?vue&type=script&lang=js"
import style0 from "./RealTimeStatus.vue?vue&type=style&index=0&id=c1a21f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a21f5a",
  null
  
)

export default component.exports